var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["faq__item", { faq_active: _vm.active }] }, [
    _c(
      "h3",
      {
        staticClass: "faq__question",
        on: {
          click: function(event) {
            return _vm.$emit("click", event)
          }
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.item.q) + "\n\n    "),
        _c("div", { staticClass: "faq__control" })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "faq__answer" }, [
      _c("p", [_vm._v("\n      " + _vm._s(_vm.item.a) + "\n    ")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }